import { BryntumSchedulerPro } from "@bryntum/schedulerpro-react"

import { schedulerConfig } from "./JobTimelineViewConfig/JobTimelineViewConfig"
import JobTimelineViewSchedulerWrapper from "./JobTimelineViewSchedulerWrapper"
import useJobTimelineViewBryntumInstances from "./hooks/useJobTimelineViewBryntumInstances"
import useJobTimelineViewSchedulerProps from "./hooks/useJobTimelineViewSchedulerProps"

export default function JobTimelineViewVerticalScheduler() {
    const { verticalProps } = useJobTimelineViewSchedulerProps()

    const { schedulerPro } = useJobTimelineViewBryntumInstances()

    return (
        <JobTimelineViewSchedulerWrapper>
            <BryntumSchedulerPro ref={schedulerPro} {...schedulerConfig} {...verticalProps} />
        </JobTimelineViewSchedulerWrapper>
    )
}
